export default __webpack_public_path__ + "static/media/contacto_5.bdb4b4f6.jpeg";